import { Accessibility as A11yIcon, Car, Heart } from "lucide-react";
import { useI18n } from "@/i18n/I18nProvider";

export function Accessibility() {
  const { t } = useI18n();
  return (
    <section id="toegankelijkheid" className="relative py-24 md:py-32">
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        <div className="film-grain relative overflow-hidden rounded-3xl border border-border bg-gradient-to-br from-night to-night-deep p-8 shadow-soft md:p-14">
          <div className="absolute -left-32 -top-32 h-80 w-80 rounded-full bg-glow opacity-50" />
          <div className="relative grid gap-10 md:grid-cols-12 md:items-center">
            <div className="md:col-span-5">
              <div className="mb-5 inline-flex h-11 w-11 items-center justify-center rounded-full bg-gold/15 text-gold">
                <A11yIcon className="h-5 w-5" />
              </div>
              <p className="font-mono-cinema text-[10px] text-gold">{t.accessibility.eyebrow}</p>
              <h2 className="mt-3 font-display text-3xl font-medium leading-[1.05] md:text-[2.5rem]">
                {t.accessibility.title}
              </h2>
              <p className="mt-5 text-foreground/70">
                {t.accessibility.body}
              </p>
            </div>

            <div className="grid gap-4 md:col-span-7 sm:grid-cols-2">
              <div className="rounded-2xl border border-border bg-night-deep/40 p-6">
                <A11yIcon className="h-5 w-5 text-gold" />
                <h3 className="mt-4 font-display text-lg">{t.accessibility.wheelchair.title}</h3>
                <p className="mt-2 text-sm text-foreground/70">{t.accessibility.wheelchair.body}</p>
              </div>
              <div className="rounded-2xl border border-border bg-night-deep/40 p-6">
                <Car className="h-5 w-5 text-gold" />
                <h3 className="mt-4 font-display text-lg">{t.accessibility.golfcart.title}</h3>
                <p className="mt-2 text-sm text-foreground/70">{t.accessibility.golfcart.body}</p>
              </div>
              <div className="rounded-2xl border border-border bg-night-deep/40 p-6 sm:col-span-2">
                <Heart className="h-5 w-5 text-gold" />
                <h3 className="mt-4 font-display text-lg">{t.accessibility.question.title}</h3>
                <p className="mt-2 text-sm text-foreground/70">{t.accessibility.question.body}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}